// extracted by mini-css-extract-plugin
export default {"inventory":"HUDInventory_inventory__kfnoX","inventoryEntry":"HUDInventory_inventoryEntry__FRrqD"};